module.exports = __webpack_public_path__ + "img/20161119_104603-1.4c8330fa.jpg";